import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  refresh() {
    if (document.visibilityState === "visible") {
      window.Turbo.visit(window.location.href, { action: "replace" })
    }
  }
}
